
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register/validate",
      function () {
        return require("private-next-pages/register/validate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register/validate"])
      });
    }
  